import { List } from '../../domain';
import { Row } from '../../components/table';
import { ListOverflowMenuButton } from './ListOverflowButton';
import { ListNameCell } from './ListNameCell';
import { ListTypeCell } from './ListTypeCell';

interface ListRowCellProps {
  list: List;
  rowIndex: number;
}

export const ListRow = ({ list, rowIndex }: ListRowCellProps) => {
  return (
    <Row index={rowIndex}>
      <ListNameCell list={list} />
      <ListTypeCell list={list} />
      <ListOverflowMenuButton list={list} />
    </Row>
  );
};
